import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AgGridModule} from 'ag-grid-angular';

//ROUTING
import {FinanzasRoutingModule} from './finanzas-routing.module';

//COMPONENTES SHARED
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {SharedModule} from 'src/app/shared/shared.module';

//COMPONENTES DEL MODULO
import {ReporteComponent} from './views/reporte-facturacion-electronica/reporte.component';
import {
  SistemaCobrosAutoserviciosComponent
} from './views/cobros-autoservicios/sistema-cobros-autoservicios/sistema-cobros-autoservicios.component';
import {
  ParametrosCobrosAutoserviciosComponent
} from './views/cobros-autoservicios/parametros-cobros-autoservicios/parametros-cobros-autoservicios.component';
import {
  ConsultaCobrosAutoserviciosComponent
} from './views/cobros-autoservicios/consulta-cobros-autoservicios/consulta-cobros-autoservicios.component';
import {
  SistemaConciliacionBancariaComponent
} from './views/conciliacion-bancaria/sistema-conciliacion-bancaria/sistema-conciliacion-bancaria.component';
import {ParametrosCbComponent} from './views/conciliacion-bancaria/parametros-cb/parametros-cb.component';
import {
  ParametrosCbParamComponent
} from './views/conciliacion-bancaria/parametros-cb-param/parametros-cb-param.component';
import {
  SistemaConciliacionBancariaPlusComponent
} from './views/conciliacion-bancaria/sistema-conciliacion-bancaria-plus/sistema-conci-banca-plus.component';
import {
  ReglasOperacionBancaComponent
} from './views/conciliacion-bancaria/reglas-operacion-banca/reglas-operacion-banca.component';
import {ExtractoBancarioComponent} from './views/extracto-bancario/extracto-bancario.component';
import {AutorizacionCobrosComponent} from './views/autorizacion-cobros/autorizacion-cobros.component';
import { ExtractoBancarioConfigComponent } from './views/extracto-bancario-config/extracto-bancario-config.component';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import { ReporteExtractoBancarioComponent } from './views/reporte-extracto-bancario/reporte-extracto-bancario.component';
import { AnulaExtractoBancoComponent } from './views/anula-extracto-banco/anula-extracto-banco.component';
import { ReporteConciliaExtratoRecuadoComponent } from './views/reporte-concilia-extrato-recuado/reporte-concilia-extrato-recuado.component';
import { ParamRechazoCobroComponent } from './views/param-rechazo-cobro/param-rechazo-cobro.component';
import { ParamConciExtractoFeriadosComponent } from './views/param-conci-extracto-feriados/param-conci-extracto-feriados.component';


@NgModule({
  declarations: [
    SistemaCobrosAutoserviciosComponent,
    ParametrosCobrosAutoserviciosComponent,
    ConsultaCobrosAutoserviciosComponent,
    SistemaConciliacionBancariaComponent,
    SistemaConciliacionBancariaPlusComponent,
    ParametrosCbComponent,
    ParametrosCbParamComponent,
    ReglasOperacionBancaComponent,
    ReporteComponent,
    ExtractoBancarioComponent,
    AutorizacionCobrosComponent,
    ExtractoBancarioConfigComponent,
    ReporteExtractoBancarioComponent,
    AnulaExtractoBancoComponent,
    ReporteConciliaExtratoRecuadoComponent,
    ParamRechazoCobroComponent,
    ParamConciExtractoFeriadosComponent
  ],
  exports: [
    SistemaCobrosAutoserviciosComponent,
    ParametrosCobrosAutoserviciosComponent,
    ConsultaCobrosAutoserviciosComponent,
    SistemaConciliacionBancariaComponent,
    SistemaConciliacionBancariaPlusComponent,
    ParametrosCbComponent,
    ParametrosCbParamComponent,
    ReglasOperacionBancaComponent,
    ReporteComponent,
    ExtractoBancarioComponent,
    AutorizacionCobrosComponent
  ],
    imports: [
        CommonModule,
        FinanzasRoutingModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
        NgxDatatableModule,
    ]
})
export class FinanzasModule {
}
